"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureImageServices = exports.validateResizeOptions = exports.DEFAULT_IMG_QUALITY = exports.RESIZE_MODES = void 0;
const gemini_1 = require("./services/gemini");
const imgix_1 = require("./services/imgix");
const lambda_1 = require("./services/lambda");
exports.RESIZE_MODES = ["resize", "crop"];
exports.DEFAULT_IMG_QUALITY = 80;
const validateResizeOptions = (mode, { width, height }) => {
    if (mode === "crop" && (!width || !height)) {
        console.warn("`crop`requires both `width` and `height`");
        return false;
    }
    if (mode === "resize" && !width && !height) {
        console.warn("`resize` requires either `width` or `height`");
        return false;
    }
    if (width && width < 1) {
        console.warn("`width` must be greater than `0`");
        return false;
    }
    if (height && height < 1) {
        console.warn("`height` must be greater than `0`");
        return false;
    }
    return true;
};
exports.validateResizeOptions = validateResizeOptions;
/**
 * Returns a list of configured services.
 * All endpoints should *not* have trailing slashes.
 */
const configureImageServices = (config) => {
    const services = {};
    if (config.gemini) {
        services.gemini = { exec: (0, gemini_1.gemini)(config.gemini) };
    }
    if (config.imgix) {
        services.imgix = { exec: (0, imgix_1.imgix)(config.imgix) };
    }
    if (config.lambda) {
        services.lambda = { exec: (0, lambda_1.lambda)(config.lambda) };
    }
    return services;
};
exports.configureImageServices = configureImageServices;
